'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linksoftAlbatros = require('linksoft-albatros');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common');

var CatalogTotalRow = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(CatalogTotalRow, _React$PureComponent);

    function CatalogTotalRow() {
        (0, _classCallCheck3.default)(this, CatalogTotalRow);
        return (0, _possibleConstructorReturn3.default)(this, (CatalogTotalRow.__proto__ || (0, _getPrototypeOf2.default)(CatalogTotalRow)).apply(this, arguments));
    }

    (0, _createClass3.default)(CatalogTotalRow, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                catalog = _props.catalog,
                includeWoVatPrice = _props.includeWoVatPrice;


            var totalPriceWoVat = catalog.items.reduce(function (sum, item) {
                return sum + item.price.totalPrice.finalPriceWithoutVat;
            }, 0);

            var totalPrice = catalog.items.reduce(function (sum, item) {
                return sum + item.price.totalPrice.finalPrice;
            }, 0);

            return _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    { className: 'text-right', colSpan: '4' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        Resx.Common.Total
                    )
                ),
                includeWoVatPrice && _react2.default.createElement(
                    'td',
                    { className: 'text-right nowrap' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        (0, _linksoftAlbatros.formatPrice)(totalPriceWoVat, _linksoftAlbatros.PriceType.CartTotalPrice)
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-right nowrap' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        (0, _linksoftAlbatros.formatPrice)(totalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                    )
                ),
                !includeWoVatPrice && _react2.default.createElement('td', null)
            );
        }
    }]);
    return CatalogTotalRow;
}(_react2.default.PureComponent), _class.propTypes = {
    catalog: _propTypes2.default.object.isRequired,
    includeWoVatPrice: _propTypes2.default.bool.isRequired
}, _temp);
exports.default = CatalogTotalRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/CatalogTotalRow.js
// module id = 635
// module chunks = 0